// extracted by mini-css-extract-plugin
export default {"formLabel":"gigReport_formLabel__UNumB"};